"use client";
import Stats from "@/components/Stats";

export interface DegreeStatsProps {
  stats: {
    label: string;
    value: string;
  }[];
  statsSectionTitle: string;
}

const DegreeStats = ({ stats, statsSectionTitle }: DegreeStatsProps) => {
  if (!stats?.length || !statsSectionTitle) {
    return null;
  }

  return (
    <section>
      {statsSectionTitle && (
        <h2 className="text-2xl lg:text-3xl text-center mt-0 mb-6 px-4 md:px-14">
          {statsSectionTitle}
        </h2>
      )}
      <div className="pb-8 bg-putty-300">
        <Stats stats={stats} background="putty-300" trackEvents={true} />
      </div>
    </section>
  );
};

export default DegreeStats;
